export const VCARD_PHONE_TYPES = ['Mobile', 'Home', 'Work', 'Office', 'Fax', 'SMS'] as const;
export const VCARD_EMAIL_TYPES = ['Work', 'Home', 'Other'] as const;
export const VCARD_ADDR_TYPES  = ['Home', 'Work', 'Other'] as const;
export const VCARD_URL_TYPES   = ['Home', 'Work', 'Other'] as const;
